// Older agency forms saved these display defaults as overrides even when
// only the app color was edited. Let those exact legacy defaults inherit.
export function inheritLegacyBrandButtons(styles = {}, appType, primaryColor) {
  const saved = styles || {};
  const result = { ...saved };
  const keys = appType === 'admin' ? ['import', 'rename', 'save', 'signin'] : ['createAdmin'];
  for (const key of keys) {
    const style = saved[key];
    if (primaryColor && primaryColor.toLowerCase() !== '#06ab8b' &&
        style?.bg?.toLowerCase() === '#06ab8b' &&
        style?.hover?.toLowerCase() === '#049572' &&
        style?.text?.toLowerCase() === '#ffffff') {
      const { bg, hover, ...rest } = style;
      result[key] = rest;
    }
  }
  return result;
}
